/**
 * Recorrência de um evento da agenda interna.
 *
 * Espelha App\Enums\Calendar\Frequency no saas. Não confundir com
 * FrequencyBlock, que é a frequência do bloqueio legado
 * (`provider_calendar_blocks`) e tem outra numeração para WEEKLY/DAILY.
 */
export enum EventFrequency {
  DOES_NOT_REPEAT = 0,
  WEEKLY = 1,
  MONTHLY = 2,
  DAILY = 3,
  CUSTOM = 4,
  ANNUAL = 5,
}

/** As opções oferecidas ao criativo — CUSTOM não tem tela e fica de fora. */
export const EVENT_FREQUENCY_OPTIONS = [
  EventFrequency.DOES_NOT_REPEAT,
  EventFrequency.WEEKLY,
  EventFrequency.MONTHLY,
  EventFrequency.DAILY,
  EventFrequency.ANNUAL,
]

export function getEventFrequencyDescription(frequency: EventFrequency) {
  switch (frequency) {
    case EventFrequency.DOES_NOT_REPEAT:
      return 'Não se repete'
    case EventFrequency.WEEKLY:
      return 'Semanal'
    case EventFrequency.MONTHLY:
      return 'Mensal'
    case EventFrequency.DAILY:
      return 'Todos os dias'
    case EventFrequency.CUSTOM:
      return 'Personalizado'
    case EventFrequency.ANNUAL:
      return 'Anual'
    default:
      return ''
  }
}
